import { createPermissionChecker, prepareIotRoutes } from '../helper';
import TabbedRouterModal from '@/components/ui/modals/TabbedRouterModal.vue';

export default prepareIotRoutes([
    {
        name: 'iot.automation',
        path: '/iot/automation',
        component: TabbedRouterModal,
        meta: {
            breadcrumbName: 'automation',
            title: 'automation',
            nonStacked: true,
            permissionChecker: createPermissionChecker(['SMART_POLICY_READ_LIST', 'PDK_AUTO_OPEN_READ_LIST']),
        },
        children: [
            {
                name: 'iot.automation.index',
                path: '/iot/automation/scenarios',
                component: () => import(/* webpackChunkName: "iot" */ '@/views/iot/automation/scenarios/Index.vue'),
                meta: {
                    actions: true,
                    title: 'scenarios',
                    flowStartsWith: 'iot.automation.index',
                    permissionChecker: createPermissionChecker('SMART_POLICY_READ_LIST'),
                },
            },
            {
                name: 'iot.auto_open.index',
                path: '/iot/automation/auto-open',
                component: () => import(/* webpackChunkName: "iot" */ '@/views/iot/automation/auto_open/Index.vue'),
                meta: {
                    actions: true,
                    title: 'auto open',
                    flowStartsWith: 'iot.auto_open.index',
                    permissionChecker: createPermissionChecker('PDK_AUTO_OPEN_READ_LIST'),
                },
            },
        ],
    },
]);
